"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const path = require("path");
const LABEL = 'Adyen payment type';
class AdyenPaymentType {
    constructor() {
        this.indexname = "adyen";
        this.label = LABEL;
        this.vueJsComponent = "adyen-payment-type";
        this.configurationComponentAssets = [
            {
                id: "adyen-payment-type_script",
                tag: "script",
                attributes: {
                    type: "text/javascript"
                },
                content: path.join(__dirname, "../../dist/adyen-settings.js")
            },
            {
                id: "adyen-payment-type_style",
                tag: "style",
                content: path.join(__dirname, "../../dist/css/app.css")
            },
            {
                id: "material-icons",
                tag: "link",
                attributes: {
                    href: "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons",
                    rel: "stylesheet"
                }
            }
        ];
        this.configurationComponentTag = "<adyen-settings></adyen-settings>";
        this.supportPartialPayment = true;
    }
    static getLabel() {
        return LABEL;
    }
}
exports.AdyenPaymentType = AdyenPaymentType;
//# sourceMappingURL=adyen-payment-type-config.js.map